import { jsx } from "react/jsx-runtime";
import { Slot, NoSlotDash } from "./UnavailableSlot.styles.js";
import "@mui/material/styles";
const UnavailableSlot = ({ visible = true }) => /* @__PURE__ */ jsx(Slot, { children: /* @__PURE__ */ jsx(NoSlotDash, { children: /* @__PURE__ */ jsx("rect", { opacity: visible ? 1 : 0, x: "0", y: "0", width: "8", height: "2" }) }) });
export {
  UnavailableSlot as default
};
